module.exports = __webpack_public_path__ + "media/images/flags/1x1/ago-3535fd8e5f7426da449741881219040e.svg";